import Link from "@mui/material/Link";
import { List, Typography, Divider } from "@mui/material";
import { FileCardListItem, FileCard } from "./FileCard";
import { Database } from "@zesty-io/material";
import { NavCodeTypes } from "../constants";
import { useTranslation } from "react-i18next";
interface Field {
  ZUID: string;
  name: string;
}
interface LinkedSchemaProps {
  file: NavCodeTypes;
  fields: Field[];
}
export default function LinkedSchema({
  file,
  fields
}: LinkedSchemaProps) {
  const {
    t
  } = useTranslation();
  return <FileCard title={t("code.linkedSchemaTitle", {
    fileName: file?.fileName
  })} icon={Database} link={`/schema/${file.contentModelZUID}`} linkLabel={t("code.editLinkedSchema")} data-sentry-element="FileCard" data-sentry-component="LinkedSchema" data-sentry-source-file="LinkedSchema.tsx">
      <Typography variant="body2" color="grey.400" data-sentry-element="Typography" data-sentry-source-file="LinkedSchema.tsx">
        {t("code.linkedSchemaBodyText")}&nbsp;
        <Link href="https://zesty.org/services/web-engine/introduction-to-parsley" target="_blank" title={t("code.learnMoreParsleySyntax")} data-sentry-element="Link" data-sentry-source-file="LinkedSchema.tsx">
          {t("code.learnMoreParsleySyntax")}
        </Link>
      </Typography>
      <Divider sx={{
      my: 1,
      border: "none"
    }} data-sentry-element="Divider" data-sentry-source-file="LinkedSchema.tsx" />
      <List sx={{
      "& span.brackets, & span.fields, & span.keywords, & a": theme => ({
        ...theme.typography.body2
      }),
      "& span.brackets": {
        color: "#95c65c"
      },
      "& span.keywords": {
        color: "#91ace8"
      },
      "& span.fields": {
        color: "grey.300"
      }
    }} data-sentry-element="List" data-sentry-source-file="LinkedSchema.tsx">
        {fields.map(field => <FileCardListItem key={field?.ZUID} gap={0}>
            <span>
              <span className="brackets">{"{{"}</span>
              {/* eslint-disable-next-line i18next/no-literal-string -- code snippet, not UI copy */}
              <span className="keywords">this.</span>
              <span className="fields">{field?.name}</span>
              <span className="brackets">{"}}"}</span>
            </span>
          </FileCardListItem>)}
      </List>
    </FileCard>;
}